interface PageMainTitle {
  category?: string
  title?: string
  titleJa?: string
  sub_title: string
  sub_title2: string
  text: string
}

export const pageMainTitle: PageMainTitle = {
  titleJa: '当社が目指しているもの',
  sub_title: '',
  sub_title2: '',
  text: '',
}
